import { render } from "./index.vue?vue&type=template&id=e689d20c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=e689d20c&lang=scss&scoped=true"

import exportComponent from "/root/workspace/interactive-system-pc_dBxe/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e689d20c"]])

export default __exports__